import { IntegrationProviderEnum, ProviderType } from '@/types/schema';

export const isTaskEditable = (provider?: ProviderType) => {
  return provider?.integrationProvider?.provider !== IntegrationProviderEnum.Jira;
};
